class MediaStreamProxy {
    audioMediaStream?: MediaStream;

    videoMediaStream?: MediaStream;

    displayMediaStream?: MediaStream;

    getVideoStreamWithTryAnotherDevices = async (options: MediaStreamConstraints): Promise<MediaStream> => {
        try {
            return await this.getVideoStream(options);
        } catch (_) {
            const videoDevices = await navigator.mediaDevices.enumerateDevices()
            .then(devices => devices.filter(d => d.kind === 'videoinput'));
            return this.getVideoStreamWithAllDevices(options, videoDevices);
        }
    }

    getVideoStreamWithAllDevices = async (options: MediaStreamConstraints, videoDevices: MediaDeviceInfo[]) => {
        const constraintsCreator = this.createVideoConstraints.bind(this, options);
        let error;
        for (let i = 0; i < videoDevices.length; i += 1) {
            try {
                // eslint-disable-next-line no-await-in-loop
                return await this.getVideoStream(constraintsCreator(videoDevices[i].deviceId));
            } catch (e) {
                error = e;
            }
        }
        throw error;
    }

    createVideoConstraints = (options: MediaStreamConstraints, deviceId: string): MediaStreamConstraints => {
        const newOptions = { ...options };
        if (typeof newOptions.video === 'boolean') {
            newOptions.video = { };
        } else {
            newOptions.video = { ...(newOptions.video || {}) };
        }
        newOptions.video.deviceId = deviceId;
        return newOptions;
    }

    getVideoStream = async (options: MediaStreamConstraints): Promise<MediaStream> => {
        if (this.videoMediaStream) return this.videoMediaStream;
        const videoStream = await navigator.mediaDevices.getUserMedia(options);

        this.videoMediaStream = videoStream;

        if (!this.audioMediaStream && videoStream.getAudioTracks().length) {
            this.audioMediaStream = new MediaStream(videoStream.getAudioTracks());
        }
        return videoStream;
    }

    getDisplayStream = async (options: MediaStreamConstraints): Promise<MediaStream> => {
        if (this.displayMediaStream) return this.displayMediaStream;
        const displayStream: MediaStream = await (navigator.mediaDevices as any).getDisplayMedia(options);

        if (!this.audioMediaStream && options.audio) {
            this.audioMediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        }

        if (this.audioMediaStream && options.audio) {
            this.audioMediaStream.getAudioTracks().forEach(track => displayStream.addTrack(track));
        }

        this.displayMediaStream = displayStream;

        return displayStream;
    }
}

export default new MediaStreamProxy();
